import { memo } from "react";
import { Flex } from "../flex";
import { BgColorValue, OverflowValue, SpacingValue } from "../theme/box";

export const FormSidePanel = memo(function SidePanel({
  children,
  className,
  side,
  fixedWidth,
  flex,
  overflowY = "auto",
  bgColor = "secondary",
  pb,
  hideScrollbar = false,
}: {
  children?: React.ReactNode;
  className?: string;
  side: "left" | "right";
  fixedWidth?: number | string;
  flex?: number;
  overflowY?: OverflowValue;
  bgColor?: BgColorValue;
  pb?: SpacingValue;
  hideScrollbar?: boolean;
}) {
  return (
    <Flex
      bgColor={bgColor}
      borderColor="primary"
      borderLeftWidth={side === "right" ? "1px" : "none"}
      borderRightWidth={side === "left" ? "1px" : "none"}
      borderStyle="solid"
      className={className}
      dir="column"
      flex={flex}
      overflowY={overflowY}
      pb={pb}
      // Keeps side panel from overflowing the page inspector
      position="relative"
      style={{
        ...(fixedWidth
          ? {
              flex: "none",
              width:
                typeof fixedWidth === "number" ? `${fixedWidth}px` : fixedWidth,
            }
          : {}),
        ...(hideScrollbar ? { scrollbarWidth: "none" as const } : {}),
      }}
      w="full"
    >
      {children}
    </Flex>
  );
});
